export enum RequestAccessErrors {
  DELETE = 'requestAccesses/deleteRequestAccess',
  CREATE = 'requestAccesses/createRequestAccess',
  EDIT = 'requestAccesses/editRequestAccess',
  GET = 'requestAccesses/getRequestAccess',
  UPDATE = 'requestAccesses/updateRequestAccess'
}
